/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import {v4 as uuidv4} from "uuid";
import isEqual from "lodash/isEqual";
/* Actions */
import {publishDashboard, resetAll} from "../../../store/dashboard/dashboard-actions";
/* Components */
import DashboardHeader from "../../../components/dashboard/dashboard-header/dashboard-header";
import GridLayout from "../../../components/common/grid-layout/grid-layout";
import DashboardPermissionsSettingsModal from "../../../components/dashboard/settings-modal/permission-settings-modal";
import DashboardImageSettingsModal from "../../../components/dashboard/settings-modal/image-settings-modal";
import DashboardInfoSettingsModal from "../../../components/dashboard/settings-modal/info-settings-modal";
import ResetConfigurationModal from "../../../components/dashboard/settings-modal/reset-configuration-modal";
import RightSideBar from "../../../components/common/right-side-bar/right-side-bar";
import WidgetTypeList from "../../../components/dashboard/widget-type-list/widget-type-list";
import BulletinWidget from "../../../components/dashboard/widgets/bulletin/bulletin";
import RSSFeedWidget from "../../../components/dashboard/widgets/rss-feed/rss-feed";
import WebPageWidget from "../../../components/dashboard/widgets/web-page/web-page";
import ScheduledActivityWidget from "../../../components/dashboard/widgets/scheduled-activity/scheduled-activity";
import GridWidget from "../../../components/dashboard/widgets/grid/grid";
import DashboardAndWidgetInfo from "../../../components/dashboard/dashboard-and-widget-info/dashboard-and-widget-info";
import DataChart from "../../../components/dashboard/widgets/data-chart/data-chart";
import Count from "../../../components/dashboard/widgets/count/count";
import NetworkTools from "../../../components/dashboard/widgets/network-tools/NetworkTools";
import UserActivityWidget from "../../../components/dashboard/widgets/user-activity/UserActivity";
import HotKeysSwitch from "../../../components/dashboard/hotkeys/hotkeys-switch";
import ShortcutOpen from "../../../components/dashboard/hotkeys/shortcut-open";
import {Prompt} from "react-router-dom";
import Modal from "../../../components/common/modal/modal";
import CloneSettingsModal from "../../../components/dashboard/settings-modal/clone-settings-modal";
import OnboardingTooltipContainer from "../../../components/onboarding/OnboardingTooltipContainer";
import Loader from "../../../components/common/loader/Loader";
import DashboardService from "../../../services/dashboard-service";
import {
    INITIAL_DASHBOARD_MODAL_FORM_DATA,
    INITIAL_WIDGETS_FILTER_PARAMS,
} from "../../../helpers/constants";
import {
    isDashboardCreatedInCurrentOrganization,
    setLatestViewInDashboards,
    setRunningDashboardId,
} from "../../../helpers/dashboard-helpers";
import UserService from "../../../services/user-service";
import {WIDGET_NAME_MAPPING} from "../../../components/dashboard/widgets/widget-constants";
import TaskList from "../../../components/dashboard/widgets/task-list/TaskList";
import DeviceInventory from "../../../components/dashboard/widgets/device-inventory/DeviceInventory";
import LicensingWidget from "../../../components/dashboard/widgets/licensing/Licensing";
import {DASHBOARD_EDIT_PAGE_LABEL, WIDGET_SECTION} from "../../../components/onboarding/constants";
import BasicCalculator from "../../../components/dashboard/widgets/basic-calculator/BasicCalculator";
import ActivityCount from "../../../components/dashboard/widgets/activity-count/ActivityCount";
import IpSubnetCalculator from "../../../components/dashboard/widgets/ip-subnet-calculator/IpSubnetCalculator";
import ROIWidget from "../../../components/dashboard/widgets/roi-widget/ROIWidget";

const initialState = {
    activeSettingsModalType: "",
    isWidgetsSidebarShown: false,
    widgetDescription: null,
    dashboardInfo: null,
    enteredFromViewInfo: false,
    dashboardInfoViewOpen: false,
    widgetsFilterParams: INITIAL_WIDGETS_FILTER_PARAMS,
    dashboard: {
        modalFormData: INITIAL_DASHBOARD_MODAL_FORM_DATA,
        layouts: {
            lg: [],
            md: [],
            sm: [],
            xs: [],
            xxs: [],
        },
        widgetsMap: {},
    },
    fetchingDashboard: false,
    warningModalOpen: false,
    maxRunningWidgets: null,
    widgetName: "",
    widgetsFilterAppliedParams: INITIAL_WIDGETS_FILTER_PARAMS,
    droppingItemSettings: {i: "Placeholder", w: 3, h: 3},
};

class DashboardPage extends React.PureComponent {
    constructor(props) {
        super(props);
        this.widgetsCount = 0;
        this.draggedWidget = null;
        const pathname = this.props.history.location.pathname;
        this.isConfigurePage = pathname.includes("edit") || pathname.includes("new");
        this.pageType = pathname.includes("edit")
            ? "edit"
            : pathname.includes("new")
            ? "new"
            : "view";
        this.isEdited = false;
        this.widgetCountByType = {};
        this.state = {
            ...initialState,
            areFiltersShown: false,
            filteredWidgets: this.props.widgetTypes,
            temporaryWidgetData: {},
            rotationPaused: false,
            isMobileMenuShown: false,
        };
    }

    componentDidMount() {
        if (this.props.id) {
            this.fetchDashboard();
        } else {
            this.setState({
                dashboard: {
                    ...this.state.dashboard,
                    modalFormData: this.props.initialModalFormData,
                },
                isWidgetsSidebarShown: true,
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            prevProps.id !== this.props.id ||
            prevProps.selectedOrganization !== this.props.selectedOrganization
        ) {
            this.fetchDashboard();
        }

        if (!isEqual(prevProps.initialModalFormData, this.props.initialModalFormData)) {
            this.changeModalFormDataInDashboard();
        }

        if (this.props.widgetTypes !== prevProps.widgetTypes) {
            this.setFilteredWidgets(this.props.widgetTypes);
        }
    }

    handleShowMobileMenu = () => {
        this.setState({
            isMobileMenuShown: !this.state.isMobileMenuShown,
        });
    };

    setFilteredWidgets = (data) => {
        this.setState({
            filteredWidgets: data,
        });
    };

    toggleWidgetFilters = () => {
        this.setState({
            areFiltersShown: !this.state.areFiltersShown,
        });
    };

    setSearchCriteria = (searchCriteria) => {
        if (this.state.searchCriteria === searchCriteria.trim()) {
            return;
        }
        this.setState({
            widgetsFilterParams: {
                ...this.state.widgetsFilterParams,
                searchCriteria: searchCriteria.trim(),
            },
        });
    };

    widgetContainsTags = (widget, tags) => {
        const widgetTagsIds = widget.tags.reduce((acc, val) => {
            return [...acc, val.id];
        }, []);
        for (let i = 0; i < tags.length; i++) {
            if (!widgetTagsIds.includes(tags[i])) {
                return false;
            }
        }
        return true;
    };

    filterApply = () => {
        if (isEqual(initialState.widgetsFilterParams, this.state.widgetsFilterParams)) {
            this.setState({
                filteredWidgets: this.props.widgetTypes,
                widgetsFilterAppliedParams: initialState.widgetsFilterParams,
            });
            return;
        }
        const tagIds = this.state.widgetsFilterParams.selectedTagsOptions.reduce((acc, val) => {
            return [...acc, val.id];
        }, []);
        const filteredWidgetTypes = this.props.widgetTypes.filter((wType) => {
            const searchFilterMatch =
                this.state.widgetsFilterParams.searchCriteria &&
                wType.title
                    .toLowerCase()
                    .includes(this.state.widgetsFilterParams.searchCriteria.toLowerCase());
            if (!this.state.widgetsFilterParams.selectedTagsOptions.length) {
                return searchFilterMatch;
            }
            const hasSelectedTags = this.widgetContainsTags(wType, tagIds);
            return hasSelectedTags || searchFilterMatch;
        });
        this.setState({
            filteredWidgets: filteredWidgetTypes,
            widgetsFilterAppliedParams: this.state.widgetsFilterParams,
        });
    };

    setTagCriteria = (selectedTagsOptions) => {
        this.setState({
            widgetsFilterParams: {
                ...this.state.widgetsFilterParams,
                selectedTagsOptions,
            },
        });
    };

    resetQueryParams = () => {
        this.setState({
            widgetsFilterParams: initialState.widgetsFilterParams,
            filteredWidgets: this.props.widgetTypes,
            widgetsFilterAppliedParams: initialState.widgetsFilterAppliedParams,
        });
    };

    changeModalFormDataInDashboard() {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                modalFormData: this.props.initialModalFormData,
            },
        });
    }

    canAddWidgetOfType = (maxRunningWidgets, baseWidgetId) => {
        if (!maxRunningWidgets) {
            return true;
        }
        const numberOfWidgets = Object.values(this.state.dashboard.widgetsMap).filter(
            (widget) => widget.typeId === baseWidgetId
        ).length;

        return numberOfWidgets < maxRunningWidgets;
    };

    async fetchDashboard() {
        this.setState({
            dashboard: initialState.dashboard,
            fetchingDashboard: true,
        });
        const dashboard = await DashboardService.getDashboard(
            this.props.id,
            true,
            this.props.widgetTypes,
            this.props.availableTags
        );
        if (
            !dashboard ||
            (this.isConfigurePage &&
                (dashboard.ownerId !== UserService.getLoggedUser().id ||
                    !isDashboardCreatedInCurrentOrganization(dashboard.tenantId)))
        ) {
            this.props.history.push("/dashboard/library");
            return;
        }

        this.setState({
            dashboard,
            fetchingDashboard: false,
        });

        if (dashboard && !this.isConfigurePage) {
            setLatestViewInDashboards(this.props.id);
            setRunningDashboardId(this.props.id);
        }
    }

    componentWillUnmount() {
        this.resetQueryParams();
        this.props.resetAll();
    }

    setActiveSettingsModalType = (modalType) => () => {
        this.setState({
            activeSettingsModalType: modalType,
        });
    };

    updateModalFormDataInDashboard = (data, prop) => {
        this.isEdited = true;
        const newModalFormData = prop
            ? {...this.state.dashboard.modalFormData, [prop]: data}
            : {...this.state.dashboard.modalFormData, ...data};
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                modalFormData: newModalFormData,
            },
        });
    };

    updateInfoSettings = (data) => {
        this.updateModalFormDataInDashboard(data);
    };

    updateImageSettings = (imageSettings) => {
        this.updateModalFormDataInDashboard(
            imageSettings.selectedImageOptionId,
            "selectedImageOptionId"
        );
        if (imageSettings.image) {
            this.updateModalFormDataInDashboard(imageSettings.image, "image");
        }
    };

    updatePermissionSettings = (selectedPermissionSettingsId) => {
        this.updateModalFormDataInDashboard(
            selectedPermissionSettingsId,
            "selectedPermissionSettingsId"
        );
    };

    updateSharedSettings = (isShared) => {
        this.updateModalFormDataInDashboard(isShared, "isShared");
    };

    handleToggleDashboardFavorite = () => {
        this.updateModalFormDataInDashboard(
            !this.state.dashboard.modalFormData.isFavorite,
            "isFavorite"
        );
    };

    toggleWidgetsSidebar = () => {
        this.setState({
            isWidgetsSidebarShown: !this.state.isWidgetsSidebarShown,
        });
    };

    toggleDashboardInfoSidebar = () => {
        this.setState({
            isWidgetsSidebarShown: !this.state.isWidgetsSidebarShown,
            dashboardInfoViewOpen: false,
        });
    };

    handleDashboardInfoClick = (dashboard) => () => {
        this.setState({
            isWidgetsSidebarShown: !this.state.isWidgetsSidebarShown,
            dashboardInfo: dashboard,
            dashboardInfoViewOpen: !this.state.dashboardInfoViewOpen,
        });
    };

    setDraggedWidget = (widget) => {
        this.draggedWidget = widget;
        const {settings} = this.props.widgetTypes.find((type) => type.id === widget.id) || {};
        this.setState({
            droppingItemSettings: {
                ...initialState.droppingItemSettings,
                w: settings.DefaultW,
                h: settings.DefaultH,
            },
        });
    };

    handleWidgetUpdate = (data) => {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                widgetsMap: {
                    ...this.state.dashboard.widgetsMap,
                    [data.id]: data,
                },
            },
        });
    };

    setLayouts = (layouts) => {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                layouts,
            },
        });
    };

    handleWidgetAddOnClik = () => {
        const baseWidgetId = this.state.widgetDescription.id;
        const maxRunningWidgets = this.state.widgetDescription.maxRunningWidgets;
        const layoutItem = {x: 0, y: 0};

        const allowAddWidget = this.canAddWidgetOfType(maxRunningWidgets, baseWidgetId);

        this.setState({
            widgetName: this.state.widgetDescription.title,
        });

        if (!allowAddWidget) {
            this.toggleModalWarning();
            this.setState({
                maxRunningWidgets,
            });
            return;
        }

        this.parseAddedWidget(this.state.widgetDescription, layoutItem, baseWidgetId);
    };

    handleWidgetAddOnDrag = (layout, layoutItem) => {
        if (!this.draggedWidget) {
            return;
        }

        const baseWidgetId = this.draggedWidget.id;
        const maxRunningWidgets = this.draggedWidget.maxRunningWidgets;

        const allowAddWidget = this.canAddWidgetOfType(maxRunningWidgets, baseWidgetId);

        this.setState({
            widgetName: this.draggedWidget.title,
        });

        if (!allowAddWidget) {
            this.toggleModalWarning();
            this.setState({
                maxRunningWidgets,
            });
            return;
        }

        this.parseAddedWidget(this.draggedWidget, layoutItem, baseWidgetId);

        this.draggedWidget = null;
    };

    parseAddedWidget = (data, layoutItem, baseWidgetId) => {
        const widgetId = uuidv4();

        const widget = {
            ...data,
            x: layoutItem.x,
            y: layoutItem.y,
            w: data.settings.DefaultW,
            h: data.settings.DefaultH,
            i: widgetId,
            id: widgetId,
            typeId: baseWidgetId,
        };

        const widgetsMap = {...this.state.dashboard.widgetsMap};
        widgetsMap[widgetId] = widget;

        this.setState((state) => {
            const newState = {
                ...state,
            };

            newState.widgetDescription = null;
            newState.widgetName = widget.title;
            newState.dashboard = {
                ...this.state.dashboard,
                widgetsMap,
            };

            return newState;
        });
    };

    handleWidgetClone = (widgetData) => () => {
        if (widgetData.e) {
            widgetData.e.persist();
        }

        this.setState({
            temporaryWidgetData: widgetData,
            activeSettingsModalType: "cloneSettings",
        });
    };

    handleWidgetCloneSave = (values) => {
        const widgetData = cloneDeep(this.state.temporaryWidgetData);
        const widgetId = uuidv4();

        let maxRunningWidgets = widgetData.maxRunningWidgets;
        if (!maxRunningWidgets) {
            maxRunningWidgets = this.props.widgetTypes.find((widget) => {
                return widget.id === this.state.temporaryWidgetData.typeId;
            }).maxRunningWidgets;
        }

        const allowAddWidget = this.canAddWidgetOfType(maxRunningWidgets, widgetData.id);

        if (!allowAddWidget) {
            this.toggleModalWarning();
            this.setState({
                maxRunningWidgets,
            });
            return;
        }

        const widget = {
            ...widgetData,
            i: widgetId,
            id: widgetId,
            isNew: true,
            title: values.itemName,
        };

        const widgetsMap = {...this.state.dashboard.widgetsMap};
        widgetsMap[widgetId] = widget;

        this.setState((state) => {
            const newState = {
                ...state,
            };

            newState.widgetName = widget.config.source;
            newState.dashboard = {
                ...this.state.dashboard,
                widgetsMap,
            };

            return newState;
        });
    };

    getWidgetType = (widgetData, isEditAllowed) => {
        const commonWidgetProps = {
            data: widgetData,
            isEditAllowed,
            showWidgetInfo: this.onWidgetCardClick,
            onRemove: this.handleWidgetRemove,
            onUpdate: this.handleWidgetUpdate,
            onClone: this.handleWidgetClone,
            isLightThemeActive: this.props.isLightThemeActive,
        };

        switch (widgetData.config.source) {
            case "DisplayWidget":
                return <BulletinWidget {...commonWidgetProps} />;
            case "RSSFeedWidget":
                return <RSSFeedWidget {...commonWidgetProps} />;
            case "WebPageWidget":
                return <WebPageWidget {...commonWidgetProps} />;
            case "ScheduledActivityWidget":
                return <ScheduledActivityWidget {...commonWidgetProps} />;
            case "UserActivityWidget":
                return <UserActivityWidget {...commonWidgetProps} />;
            case "GridWidget":
                return (
                    <GridWidget
                        {...commonWidgetProps}
                        osMap={Object.entries(this.props.osMap).map(([, title]) => ({
                            value: title,
                            title,
                        }))}
                        osPaths={this.props.osPaths}
                        fileServersMap={this.props.fileServersMap}
                        selectedOrganization={this.props.selectedOrganization}
                        isMobileDevice={this.props.isMobileDevice}
                        openSolutionsInNewTab={this.props.openSolutionsInNewTab}
                    />
                );
            case "DatasetChartWidget":
                return (
                    <DataChart
                        {...commonWidgetProps}
                        osMap={Object.entries(this.props.osMap).map(([, title]) => ({
                            value: title,
                            title,
                        }))}
                        osPaths={this.props.osPaths}
                        fileServersMap={this.props.fileServersMap}
                        selectedOrganization={this.props.selectedOrganization}
                        isMobileDevice={this.props.isMobileDevice}
                        openSolutionsInNewTab={this.props.openSolutionsInNewTab}
                    />
                );
            case "CountWidget":
                return (
                    <Count
                        {...commonWidgetProps}
                        osMap={Object.entries(this.props.osMap).map(([, title]) => ({
                            value: title,
                            title,
                        }))}
                        osPaths={this.props.osPaths}
                        fileServersMap={this.props.fileServersMap}
                        selectedOrganization={this.props.selectedOrganization}
                        isMobileDevice={this.props.isMobileDevice}
                        openSolutionsInNewTab={this.props.openSolutionsInNewTab}
                    />
                );
            case "TaskListWidget":
                return <TaskList {...commonWidgetProps} />;
            case "ROIWidget":
                return <ROIWidget {...commonWidgetProps} />;

            case "InventorySummary":
                return (
                    <DeviceInventory
                        {...commonWidgetProps}
                        isMobileDevice={this.props.isMobileDevice}
                        openSolutionsInNewTab={this.props.openSolutionsInNewTab}
                    />
                );

            case "LicenseSummary":
                return (
                    <LicensingWidget
                        {...commonWidgetProps}
                        isMobileDevice={this.props.isMobileDevice}
                        openSolutionsInNewTab={this.props.openSolutionsInNewTab}
                    />
                );

            case "NetworkTools":
                return <NetworkTools {...commonWidgetProps} />;

            case "BasicCalculator":
                return <BasicCalculator {...commonWidgetProps} />;
            case "TotalChangeCount":
                return (
                    <ActivityCount
                        {...commonWidgetProps}
                        isMobileDevice={this.props.isMobileDevice}
                        openSolutionsInNewTab={this.props.openSolutionsInNewTab}
                    />
                );
            case "Ipv4SubnetCalculator":
                return <IpSubnetCalculator {...commonWidgetProps} />;
            default:
                return null;
        }
    };

    handleWidgetRemove = (widget) => () => {
        const widgets = cloneDeep(this.state.dashboard.widgetsMap);
        delete widgets[widget.id];

        this.setState((state) => {
            const newState = {
                ...state,
            };

            if (this.state.widgetDescription && widget.id === this.state.widgetDescription.id) {
                newState.widgetDescription = null;
            }

            newState.dashboard = {
                ...this.state.dashboard,
                widgetsMap: widgets,
            };

            return newState;
        });
    };

    onLayoutChange = (layout, layouts) => {
        if (this.draggedWidget) {
            return;
        }

        if (!this.widgetData) {
            this.setLayouts(layouts);
            return;
        }

        let isLayoutFound = false;
        const newLayouts = {...layouts};
        Object.keys(newLayouts).forEach((layoutKey) => {
            if (layouts[layoutKey] === layout) {
                const currentLayoutCopy = layouts[layoutKey].slice();
                const foundIndex = currentLayoutCopy.findIndex(
                    (widget) => widget.i === this.widgetData.i
                );
                if (foundIndex >= 0) {
                    isLayoutFound = true;
                    currentLayoutCopy[foundIndex] = {
                        ...currentLayoutCopy[foundIndex],
                        x: this.widgetData.x,
                        y: this.widgetData.y,
                        w: this.widgetData.w || this.widgetData.settings.DefaultW,
                        h: this.widgetData.h || this.widgetData.settings.DefaultH,
                        minH: this.widgetData.settings.MinH,
                        minW: this.widgetData.settings.MinW,
                        maxH: this.widgetData.settings.MaxH || Infinity,
                        maxW: this.widgetData.settings.MaxW || Infinity,
                    };
                    newLayouts[layoutKey] = currentLayoutCopy;
                }
            }
        });

        if (isLayoutFound) {
            this.setLayouts(newLayouts);
            this.widgetData = null;
        }
    };

    getSpreadedWidgetData = (widget, widgetTypeId) => {
        const specificWidgetType = this.props.widgetTypes.find(
            (widgetType) => widgetType.id === widgetTypeId
        );
        return specificWidgetType
            ? {
                  ...widget,
                  tags: specificWidgetType.tags,
                  images: specificWidgetType.images,
                  description: specificWidgetType.description,
              }
            : widget;
    };

    onWidgetCardClick = (widget) => () => {
        const enteredFromViewInfo = !!widget.typeId;
        const tempWidget = this.getSpreadedWidgetData(widget, widget.typeId || widget.id);
        this.setState({
            isWidgetsSidebarShown: true,
            widgetDescription: tempWidget,
            enteredFromViewInfo,
        });
    };

    onWidgetInfoClose = () => {
        this.setState({
            widgetDescription: null,
        });
    };

    getImage = (modalFormData) => {
        if (modalFormData.selectedImageOptionId === "DEFAULT") {
            return modalFormData.defaultImage || this.props.defaultImageBase64;
        }
        if (modalFormData.selectedImageOptionId === "CUSTOM") {
            return modalFormData.image;
        }
        return null;
    };

    resetGridData = () => {
        this.setState({
            dashboard: {
                ...this.state.dashboard,
                widgetsMap: {},
                layouts: {},
            },
        });
    };

    onPublish = () => {
        this.isEdited = false;
        return this.props.publishDashboard(
            this.props.history,
            this.props.id,
            this.state.dashboard,
            this.props.queryParams,
            this.props.widgetTypes
        );
    };

    shouldAllowNavigation = (location) => {
        if (location.hash || !this.isConfigurePage || !this.isEdited) {
            return true;
        }
        return "Changes will be discarded if you leave page.";
    };

    toggleModalWarning = () => {
        this.setState({
            warningModalOpen: !this.state.warningModalOpen,
        });
    };

    getLabelForWidgetName = (widgetName) =>
        WIDGET_NAME_MAPPING[widgetName] || widgetName.toLowerCase();

    renderWarningModal = (maxRunningWidgets, widgetName) => {
        return (
            <Modal.Default isOpen={this.state.warningModalOpen}>
                <div className="glu-modal__header glu-flex glu-flex-align-center">
                    <div className="glu-modal__title glu-flex-grow">Maximum number exceeded</div>
                    <div className="glu-flex-shrink">
                        <button
                            aria-label="close"
                            type="button"
                            className="glu-btn-link g-icon g-icon-close"
                            onClick={this.toggleModalWarning}
                        />
                    </div>
                </div>
                <div className="glu-modal__body">
                    <div className="glu-content__section">
                        <p className="glu-h5 glu-dashboard-reset-configuration text-secondary--line-height">
                            Sorry! You can only have {maxRunningWidgets}{" "}
                            {this.getLabelForWidgetName(widgetName)}
                            {maxRunningWidgets > 1 ? " widgets" : " widget"} on a dashboard.
                        </p>
                    </div>
                </div>
                <footer className="glu-modal__footer">
                    <div className="glu-flex-grow glu-flex-row glu-flex-justify-end">
                        <button
                            className="glu-btn glu-btn--primary"
                            onClick={this.toggleModalWarning}
                        >
                            OK
                        </button>
                    </div>
                </footer>
            </Modal.Default>
        );
    };

    togglePauseRotation = () => {
        this.setState({rotationPaused: !this.state.rotationPaused});
    };

    render() {
        const modalFormData = this.state.dashboard.modalFormData;
        const isPermissionSettingsModalShown =
            this.state.activeSettingsModalType === "permissionSettings";
        const isImageSettingsModalShown = this.state.activeSettingsModalType === "imageSettings";
        const isInfoSettingsModalShown = this.state.activeSettingsModalType === "infoSettings";
        const isResetModalShown = this.state.activeSettingsModalType === "resetConfiguration";
        const isCloneSettingsModalShown = this.state.activeSettingsModalType === "cloneSettings";
        let pageClassName = "glu-page__body";
        if (this.state.isMobileMenuShown) {
            pageClassName += " glu-page__body--margin-top";
        }
        return (
            <div className="glu-page glu-page--has-header glu-dashboard-grid-view">
                <Prompt message={this.shouldAllowNavigation} />
                {!this.state.fetchingDashboard && this.state.dashboard ? (
                    <DashboardHeader
                        history={this.props.history}
                        id={this.props.id}
                        title={this.state.dashboard.modalFormData.dashboardName}
                        setActiveSettingsModalType={this.setActiveSettingsModalType}
                        toggleWidgetsSidebar={this.toggleWidgetsSidebar}
                        resetConfiguration={this.resetGridData}
                        onPublish={this.onPublish}
                        isPublishDisabled={
                            this.state.dashboard.modalFormData.dashboardName.length === 0 ||
                            !Object.keys(this.state.dashboard.widgetsMap).length
                        }
                        isEditAllowed={this.isConfigurePage}
                        isFavorite={this.state.dashboard.modalFormData.isFavorite}
                        toggleDashboardFavorite={this.handleToggleDashboardFavorite}
                        image={this.getImage(this.state.dashboard.modalFormData)}
                        currentDashboard={this.state.dashboard}
                        handleDashboardInfoClick={this.handleDashboardInfoClick}
                        dashboard={this.state.dashboard}
                        isWidgetsSidebarShown={this.state.isWidgetsSidebarShown}
                        dashboardInfoViewOpen={this.state.dashboardInfoViewOpen}
                        togglePauseRotation={this.togglePauseRotation}
                        rotationPaused={this.state.rotationPaused}
                        dashboardRotation={this.props.dashboardRotation}
                        handleShowMobileMenu={this.handleShowMobileMenu}
                        isMobileMenuShown={this.state.isMobileMenuShown}
                    />
                ) : null}
                <div className={pageClassName}>
                    {this.state.fetchingDashboard && <Loader />}
                    {!this.state.fetchingDashboard && this.state.dashboard ? (
                        <GridLayout
                            isResizable={this.isConfigurePage}
                            onLayoutChange={this.onLayoutChange}
                            onDrop={this.handleWidgetAddOnDrag}
                            layouts={this.state.dashboard.layouts}
                            droppingItemSettings={this.state.droppingItemSettings}
                        >
                            {Object.entries(this.state.dashboard.widgetsMap).map(
                                ([widgetKey, widget]) => (
                                    <div
                                        data-grid={{
                                            h: widget.h,
                                            w: widget.w,
                                            x: widget.x,
                                            y: widget.y,
                                        }}
                                        key={widgetKey}
                                        tooltip-id="widget"
                                    >
                                        {this.getWidgetType(widget, this.isConfigurePage)}
                                    </div>
                                )
                            )}
                        </GridLayout>
                    ) : null}
                    {Object.keys(this.state.dashboard.widgetsMap).length > 0 && (
                        <OnboardingTooltipContainer
                            page={DASHBOARD_EDIT_PAGE_LABEL}
                            section={WIDGET_SECTION}
                        />
                    )}
                </div>
                {isCloneSettingsModalShown && (
                    <CloneSettingsModal
                        isOpen={isCloneSettingsModalShown}
                        onClose={this.setActiveSettingsModalType("")}
                        onSave={this.handleWidgetCloneSave}
                    />
                )}
                {isPermissionSettingsModalShown && (
                    <DashboardPermissionsSettingsModal
                        isOpen={isPermissionSettingsModalShown}
                        onClose={this.setActiveSettingsModalType("")}
                        onSave={this.updatePermissionSettings}
                        onSaveShared={this.updateSharedSettings}
                        selectedPermissionSettingsId={modalFormData.selectedPermissionSettingsId}
                        isShared={modalFormData.isShared}
                        permissionSettingsOptions={this.props.permissionSettingOptions}
                    />
                )}
                {isImageSettingsModalShown && (
                    <DashboardImageSettingsModal
                        isOpen={isImageSettingsModalShown}
                        onClose={this.setActiveSettingsModalType("")}
                        onSave={this.updateImageSettings}
                        selectedImageOptionId={modalFormData.selectedImageOptionId}
                        imageUploadOptions={this.props.imageUploadOptions}
                        defaultImage={this.props.defaultImageBase64}
                        image={modalFormData.image}
                    />
                )}
                {isInfoSettingsModalShown && (
                    <DashboardInfoSettingsModal
                        isOpen={isInfoSettingsModalShown}
                        onClose={this.setActiveSettingsModalType("")}
                        onSave={this.updateInfoSettings}
                        dashboardName={modalFormData.dashboardName}
                        dashboardDescription={modalFormData.dashboardDescription}
                    />
                )}
                {isResetModalShown && (
                    <ResetConfigurationModal
                        onClose={this.setActiveSettingsModalType("")}
                        onConfirm={this.resetGridData}
                        isOpen={isResetModalShown}
                        dashboardName={this.state.dashboard.modalFormData.dashboardName}
                    />
                )}
                <RightSideBar isCollapsed={!this.state.isWidgetsSidebarShown}>
                    {this.state.widgetDescription ? (
                        <DashboardAndWidgetInfo
                            description={this.state.widgetDescription.description}
                            isWidget
                            onActionCb={this.handleWidgetAddOnClik}
                            onClose={this.onWidgetInfoClose}
                            tags={this.state.widgetDescription.tags}
                            title={this.state.widgetDescription.title}
                            enteredFromViewInfo={this.state.enteredFromViewInfo}
                            widgetDescriptionImage={
                                this.state.widgetDescription.images
                                    ? this.state.widgetDescription.images[
                                          this.props.isLightThemeActive ? "LIGHT" : "DARK"
                                      ]
                                    : ""
                            }
                        />
                    ) : (
                        <WidgetTypeList
                            onDragStart={this.setDraggedWidget}
                            widgets={this.state.filteredWidgets}
                            onClose={this.toggleWidgetsSidebar}
                            onWidgetCardClick={this.onWidgetCardClick}
                            availableTags={this.props.availableTags}
                            areFiltersShown={this.state.areFiltersShown}
                            toggleWidgetFilters={this.toggleWidgetFilters}
                            setSearchCriteria={this.setSearchCriteria}
                            widgetsFilterParams={this.state.widgetsFilterParams}
                            setTagCriteria={this.setTagCriteria}
                            resetQueryParams={this.resetQueryParams}
                            filterApply={this.filterApply}
                            resetDisabled={isEqual(
                                this.state.widgetsFilterParams,
                                initialState.widgetsFilterParams
                            )}
                            applyDisabled={isEqual(
                                this.state.widgetsFilterAppliedParams,
                                this.state.widgetsFilterParams
                            )}
                            isShown={this.state.isWidgetsSidebarShown}
                            isInitiallyOpened={this.pageType === "new"}
                        />
                    )}
                </RightSideBar>
                {!this.isConfigurePage && (
                    <RightSideBar isCollapsed={!this.state.isWidgetsSidebarShown}>
                        {this.state.dashboardInfo ? (
                            <DashboardAndWidgetInfo
                                description={this.state.dashboardInfo.description}
                                createdBy={this.state.dashboardInfo.createdBy}
                                ownerId={this.state.dashboardInfo.ownerId}
                                createdOn={this.state.dashboardInfo.createdOn}
                                createdIn={this.state.dashboardInfo.createdIn}
                                title={this.state.dashboardInfo.title}
                                onClose={this.toggleDashboardInfoSidebar}
                                tags={this.state.dashboardInfo.tags}
                                widgetTitleList={this.state.dashboardInfo.widgetTitleList}
                                gridView
                            />
                        ) : null}
                    </RightSideBar>
                )}
                {(this.props.shortcutAndHotkeysOptions.enableFavoriteHotkeys ||
                    this.props.dashboardRotation) && (
                    <HotKeysSwitch
                        currentDashboard={this.state.dashboard}
                        favorites={this.props.favoriteDashboards}
                        history={this.props.history}
                        dashboardRotation={this.props.dashboardRotation}
                        rotationPaused={this.state.rotationPaused}
                        isEditAllowed={this.isConfigurePage}
                        hotkeysEnabled={this.props.shortcutAndHotkeysOptions.enableFavoriteHotkeys}
                    />
                )}
                {this.props.shortcutAndHotkeysOptions.enableFavoriteShortcuts && (
                    <ShortcutOpen
                        favorites={this.props.favoriteDashboards}
                        history={this.props.history}
                    />
                )}
                {this.renderWarningModal(this.state.maxRunningWidgets, this.state.widgetName)}
            </div>
        );
    }
}

DashboardPage.propTypes = {
    id: PropTypes.string,
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    imageUploadOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
    permissionSettingOptions: PropTypes.arrayOf(PropTypes.any).isRequired,
    publishDashboard: PropTypes.func.isRequired,
    resetAll: PropTypes.func.isRequired,
    widgetTypes: PropTypes.arrayOf(PropTypes.any).isRequired,
    availableTags: PropTypes.objectOf(PropTypes.any).isRequired,
    defaultImageBase64: PropTypes.string.isRequired,
    osPaths: PropTypes.objectOf(PropTypes.any).isRequired,
    osMap: PropTypes.objectOf(PropTypes.any).isRequired,
    shortcutAndHotkeysOptions: PropTypes.objectOf(PropTypes.any).isRequired,
    dashboardRotation: PropTypes.number.isRequired,
    favoriteDashboards: PropTypes.arrayOf(PropTypes.any).isRequired,
    fileServersMap: PropTypes.arrayOf(PropTypes.any),
    isLightThemeActive: PropTypes.bool.isRequired,
    initialModalFormData: PropTypes.objectOf(PropTypes.any).isRequired,
    selectedOrganization: PropTypes.objectOf(PropTypes.any),
    queryParams: PropTypes.objectOf(PropTypes.any),
    isMobileDevice: PropTypes.bool,
};

DashboardPage.defaultProps = {
    id: null,
    selectedOrganization: null,
    queryParams: {},
    isMobileDevice: false,
    fileServersMap: [],
};

function mapStateToProps(state) {
    return {
        imageUploadOptions: state.dashboardReducer.imageUploadOptions,
        permissionSettingOptions: state.dashboardReducer.permissionSettingOptions,
        widgetTypes: state.dashboardReducer.widgetTypes,
        availableTags: state.dashboardReducer.availableTags,
        widgetTypesLoaded: state.dashboardReducer.widgetTypesLoaded,
        defaultImageBase64: state.dashboardReducer.defaultImageBase64,
        osPaths: state.dashboardReducer.osPaths,
        osMap: state.dashboardReducer.osMap,
        shortcutAndHotkeysOptions: state.userReducer.shortcutAndHotkeysOptions,
        dashboardRotation: state.userReducer.dashboardRotation,
        favoriteDashboards: state.dashboardReducer.favoriteDashboards,
        fileServersMap: state.dashboardReducer.fileServersMap,
        isLightThemeActive: state.userReducer.isLightThemeActive,
        initialModalFormData: state.dashboardReducer.modalFormData,
        selectedOrganization: state.userReducer.selectedOrganization,
        queryParams: state.userReducer.queryParams,
        isMobileDevice: state.userReducer.isMobileDevice,
        openSolutionsInNewTab: state.userReducer.openSolutionsInNewTab,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        publishDashboard: (history, id, dashboard, queryParams, widgetTypes) =>
            publishDashboard(dispatch, history, id, dashboard, queryParams, widgetTypes),
        resetAll: () => resetAll(dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
